"use client";

import { useState, useCallback } from 'react';
import { SearchResult, SearchOptions } from './types';
import { SearchService } from './searchService';

export function useSearch(options: SearchOptions) {
  const [searchResult, setSearchResult] = useState<SearchResult>({
    item: [],
    totalItems: 0
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  const searchService = new SearchService(options);

  const search = useCallback(async (category: string, query: string) => {
    setLoading(true);
    setError(undefined);

    try {
      const result = await searchService.searchItems(category, query);
      setSearchResult(result);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Произошла ошибка при поиске';
      setError(errorMessage);
      setSearchResult({
        item: [],
        totalItems: 0,
        error: errorMessage
      });
    } finally {
      setLoading(false);
    }
  }, [searchService]);

  const clearSearch = useCallback(() => {
    setSearchResult({
      item: [],
      totalItems: 0
    });
    setError(undefined);
  }, []);

  return {
    searchResult,
    loading,
    error,
    search,
    clearSearch
  };
}
